import { useMutation } from "@tanstack/react-query";
import axios from "axios";

const baseUrl = process.env.REACT_APP_API_BASE_URL;

export default function usePostToBackend({ path, options = {} }) {
  return useMutation({
    mutationFn: async (payload) => {
      const response = await axios.post(`${baseUrl}${path}`, payload);
      return response.data;
    },
    ...options,
  });
}
